var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mds-tag',{class:`tag--${_vm.status.toLowerCase()}`,attrs:{"text":_vm.status}})
}
var staticRenderFns = []

export { render, staticRenderFns }